import { connectedStore } from '../../store';
import selectors from '../selectors';

const getDesignAutomation = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getDesignAutomation(state);
};

export default getDesignAutomation;
